import React from 'react'
import Show from 'services/Show';
import { handleErrors, formatDate } from 'services/utils'
import { fciGroups } from 'services/constants'
import { Spinner } from 'components/atoms';
import CollapsibleFieldset from 'components/CollapsibleFieldset';

export default class ShowExpertsByBreed extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      show: {},
      breeds: [],
      breedsByGroup: [],
      showId: match.params.id,
      successSave: false,
    }
    this.mounted = false;
    this.changed = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    Show.withBreeds(this.state.showId).then(({show, breeds}) => {
      if (this.mounted) {
        const breedsByGroup = fciGroups.map(group => {
          const groupedBreeds = breeds.filter(breed => breed.fci_group === group.id)
          return {...group, breeds: groupedBreeds}; 
        }).filter(group => group.breeds.length > 0);
        show = new Show(show);
        this.setState( { show, breeds, breedsByGroup, loading: false } );
      }
    }).catch((request) => {
      this.setState({loading: false});
      handleErrors(request);
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  saveChanges = (e) => {
    e.preventDefault();
    const show = this.state.show;
    show.experts_breeds = show.breed_experts_map;
    this.setState({ successSave: false, busy:true });
    show.save().then((item) => {
      if (!this.mounted) return; 
      this.setState({ successSave: true, busy: false });
      this.changed = false;
    }).catch((request) => {
      this.setState({busy: false});
      handleErrors(request);
    });
  }

  groupExpertChosen = ({target}) => {
    const groupId = parseInt((target.id || '').replace(/\D/g,''));
    const expertId = parseInt(target.value);
    if (groupId >= 0 && expertId) {
      const show = this.state.show;
      const groupExpert = show.invited_experts.find(expert => expert.id === expertId);
      const group = this.state.breedsByGroup.find(group => group.id === groupId);
      if (groupExpert && group) {
        group.breeds.forEach(breed => {
          show.breed_experts_map[breed.id] = groupExpert.id;  
        });
        this.setState({ show });
        this.changed = true;
      }
    }
  }

  breedExpertChosen = ({target}) => {
    const breedId = parseInt((target.id || '').replace(/\D/g,''));
    const expertId = parseInt(target.value);
    if (breedId && expertId) {
      const show = this.state.show;
      show.breed_experts_map[breedId] = expertId;
      this.setState({ show });
      this.changed = true;
    }
  }

  render() {
    const {show, breedsByGroup, loading} = this.state;
    let showInfo = null;
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }
    const groupLinks = <div className="m-3">{breedsByGroup.map(group => (
      <a href={'#fieldset-'+group.id} key={group.id} className="me-3">{group.name}</a>
    ))}</div>;

    const groupedBreeds = breedsByGroup.map(group => {
        let matched = 0;
        group.breeds.forEach(breed => {
          if (show.breed_experts_map[breed.id]) {
            matched ++;
          }
        });
        const expertsForGroup = show.invited_experts.map(expert => {
          if (expert.fci_groups.includes(group.id)) return expert;
          const breed = group.breeds.find(breed => expert.breed_ids.includes(breed.id));
          if (breed) return expert;
          return null; 
        }).filter(expert => expert);
        const expertOptions = expertsForGroup.map(expert => <option key={expert.id} value={expert.id}>{expert.name}</option>)

        return (
          <CollapsibleFieldset 
             id={"fieldset-"+group.id}
             key={group.id}
             title={group.name + ' ( ' + matched + ' / ' + group.breeds.length + ' )'} 
             open={true}
             className="m-3">
            <label className="m-3">
              <select id={'group-'+group.id} data-group-id={group.id} 
                className="form-select form-select-sm" onChange={this.groupExpertChosen}>
                <option>Выставить эксперта для каждой породы группы</option>
                {expertOptions}
              </select>
            </label>
            <BreedsList breeds={group.breeds} show={show} expertOptions={expertOptions} onChange={this.breedExpertChosen} />
          </CollapsibleFieldset>
        )
    });

    const buttons = (
      <div className="row">
        <div className="col-md-12 m-3">
          <button type="button" onClick={this.saveChanges} disabled={this.state.busy || !this.changed} className="btn btn-primary me-2">
            { this.state.busy && <Spinner /> }
            Сохранить
          </button>
          <button type="button" onClick={this.onCancel} disabled={this.state.busy} className="btn btn-light">
            { this.state.busy && <Spinner /> }
            Назад
          </button>
        </div>
      </div>
    );

    return (
      <div className="container-fluid">
        <h4>Эксперты выставки - {showInfo}</h4>
        <h5>Расклад по породам</h5>
        
        { this.state.successSave && 
         <div className="row alert alert-success">
          Изменения успешно сохранены.
         </div>}

        {loading && <Spinner /> }
        
        {groupLinks}

        {buttons}
        {groupedBreeds}
        {buttons}


      </div>
    );
  }
}


function BreedsList(props) {
  const {breeds, show, expertOptions, onChange} = props;
  return (
    <ul className="m-3">
      {breeds.map(breed => {
        const currentExpertId = show.breed_experts_map[breed.id] || '';
        return (<li key={breed.id} className="row">
            <div className="col-1 mb-3">{ breed.fci_num }</div>
            <div className="col-5">{ breed.name }</div>
            <div className="col-4">
              <select id={'breed-'+breed.id} value={currentExpertId} 
                className="form-select form-select-sm" onChange={onChange}>
                <option>выберите эксперта породы</option>
                {expertOptions}
              </select>
            </div>
        </li>);
      })}
    </ul>
  );
}